<template>
  <div>
    <b-media :key="resource.id" class="mb-2">
      <template v-slot:aside>
        <i :class="iconClass" style="font-size:42px; line-height:42px; color:#9a4e8a;"></i>
      </template>
      <h5 class="mt-0 mb-2 media-heading">
        <div v-if="resource.type=='file'">
          <a href="#" @click.prevent="getResource(resource)">{{ resource.name }}</a>
        </div>
        <div v-else>
          <a :href="resource.url" target="_blank">{{ resource.name }}</a>
        </div>
      </h5>
      <p class="mb-2 text-muted">{{ resource.info }}</p>
      <hr />
    </b-media>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["resource"],
  computed: {
    iconClass() {
      let icon = "far fa-file-alt";
      switch (this.resource.ext) {
        case "doc":
        case "docx":
        case "odt":
          icon = "far fa-file-word";
          break;
        case "pdf":
          icon = "far fa-file-pdf";
          break;
        case "xls":
        case "xlsx":
        case "ods":
        case "xml":
          icon = "far fa-file-excel";
          break;
        case "zip":
        case "7zip":
        case "rar":
        case "tar":
        case "tar.gz":
          icon = "far fa-file-archive";
          break;
        default:
          icon = "far fa-file-alt";
          break;
      }
      if (this.resource.type == 'link') {
        icon = "fas fa-link";
      }
      return icon;
    }
  },
  methods: {
    ...mapActions({ download: "resources/downloadResource" }),
    getResource() {
      this.download(this.resource)
        .then()
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>